import { FinanceBalanceType } from './balance.types'

// С бэка типов не приходит, но согласовано,
// что элементы всегда приходят с одинаковой последовательностью
export const financeBalanceTypes: FinanceBalanceType[] = [
  FinanceBalanceType.RegularPayment, // ЖКУ и доп.услуги
  FinanceBalanceType.MajorRenovation // Капитальный ремонт
]
